export const JURNI_CORE_APP_ID =
  "51e0829e-f6f8-4328-8662-ab39f09b4d22/jurni-core";
export const SHOPIFY_PAGE_TEMPLATE = "page";
export const SHOPIFY_PAGES_SETUP_REDIRECT_COOKIE =
  "jurni_shopify_pages_setup_redirect";
export const SHOPIFY_PAGE_PUBLISH_SCOPE = "write_content";

export const getJurniCoreActivationLink = (shopDomain: string) => {
  return `https://${shopDomain}/admin/themes/current/editor?context=apps&template=index&activateAppId=${JURNI_CORE_APP_ID}`;
};

// export const getJurniCorePageTemplateEditorLink = (shopDomain: string) => {
//   return `https://${shopDomain}/admin/themes/current/editor?template=${SHOPIFY_PAGE_TEMPLATE}`;

// temp - need to fix

export const getJurniCorePageTemplateEditorLink = (shopDomain: string) => {
  return `https://${shopDomain}/admin`;
};
